var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    fill: "#F1F4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9227 15.6386L9.39237 15.1083L9.9227 15.6386L14.531 11.0303C14.5497 11.0117 14.5685 10.9929 14.5874 10.9741C14.8011 10.7615 15.0247 10.539 15.1545 10.277L14.4825 9.94402L15.1545 10.277C15.3971 9.78742 15.3971 9.21258 15.1545 8.72297L14.4825 9.05598L15.1545 8.72297C15.0247 8.46101 14.8011 8.23852 14.5874 8.02588C14.5685 8.00707 14.5497 7.98834 14.531 7.96967L14.0007 8.5L14.531 7.96967C14.5123 7.951 14.4936 7.93218 14.4748 7.91328C14.2621 7.69958 14.0396 7.47599 13.7777 7.34618C13.2881 7.10356 12.7132 7.10356 12.2236 7.34618C11.9617 7.47599 11.7392 7.69958 11.5265 7.91328C11.5077 7.93218 11.489 7.951 11.4703 7.96967L6.86204 12.578C6.84947 12.5905 6.8368 12.6031 6.82405 12.6158C6.66779 12.7715 6.49978 12.9388 6.38077 13.149C6.26175 13.3592 6.20469 13.5894 6.15163 13.8035C6.1473 13.8209 6.143 13.8383 6.13869 13.8555L5.80849 15.1763C5.80587 15.1868 5.8032 15.1974 5.80048 15.2083C5.76265 15.3591 5.71628 15.5439 5.70063 15.7039C5.68295 15.8846 5.68137 16.2411 5.97047 16.5302C6.25956 16.8193 6.61607 16.8177 6.79678 16.8C6.95673 16.7844 7.14159 16.738 7.29239 16.7002C7.30322 16.6974 7.31388 16.6948 7.32434 16.6922L8.64512 16.362C8.66236 16.3577 8.67972 16.3534 8.6972 16.349C8.91126 16.296 9.14142 16.2389 9.35162 16.1199C9.56183 16.0009 9.72917 15.8329 9.8848 15.6766C9.89751 15.6639 9.91013 15.6512 9.9227 15.6386Z",
    stroke: "#4880FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.334 8.50033L13.334 7.16699L15.334 9.16699L14.0007 11.167L11.334 8.50033Z",
    fill: "#4880FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilActive);
export default __webpack_public_path__ + "static/media/pencil_active.6e60a88287e5de646803bda7e176217b.svg";
export { ForwardRef as ReactComponent };